import styled from '@emotion/styled';

const RecaptchaContainerStyled = styled.div`
  label: RecaptchaContainerStyled;

  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
  margin-bottom: 1.875rem;
`;

export default RecaptchaContainerStyled;
